import Component from './account_select.vue'
export default Component
